export * from './krankheit.service';
export * from './krankheiten';
